import Alea from 'alea';
import SimplexNoise from 'simplex-noise';
import { CompositionEffect, DURATION_LONG } from './CompositionEffect';

const seed = new (Alea as any)(0);
const noise = new SimplexNoise(seed);

const FACTOR = 4;
let X = 0.4;

class Composition extends CompositionEffect {
  static id = 'composition-neon';
  static label = 'Neon';

  protected compose(position: number) {
    const v = noise.noise2D(X, position * FACTOR);
    this.layer.sprite.alpha = Math.min(1, Math.max(0, 0.5 + v * 3));
  }
  protected decompose(position: number) {
    const v = noise.noise2D(X, (1 - position) * FACTOR);
    this.layer.sprite.alpha = Math.min(1, Math.max(0, 0.5 + v * 3));
  }

  getInitialDuration(): string {
    return DURATION_LONG;
  }
}

(window as any).BeatFlyer.compositions[Composition.id] = Composition;



// WEBPACK FOOTER //
// ./src/compose/ComposeNeon.ts